exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer-bar-container{background-color:#003152;position:fixed;overflow:hidden;left:0;bottom:0;width:100%;z-index:999999;color:#fff;height:60px;text-align:center}.footer-bar-container .spi-logo{float:left;border:1px solid #fff;width:72px;height:42px;margin:10px}.footer-bar-container .footer-links{list-style-type:none;color:#fff;float:right;display:inline}.footer-bar-container .link{display:inline-block;float:right;margin-right:20px;margin-top:17px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/reusableComponents/Footer/footerbar.scss
// module id = 1366
// module chunks = 0